module.exports = __webpack_public_path__ + "static/1.2.A. CAIAN RANDARE 2-ca49c5e775bc6082511e408e6cc0a3af.jpg";